
import { formatCurrency } from '../utils/currencyHelper';
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { imgUrl } from "src/actions/types";
import { getAllUsers } from "src/actions/loginAction";
import { connect } from "react-redux";
import { updateUser } from "src/actions/loginAction";
import { getAccountStatus } from "src/actions/businessModuleActions";
import { fetchSpecialities } from "../../actions/specialityAction";
import { getBusinessAddons } from "../../actions/businessAddonActions";
import {
  getDoctorProfileById,
  submitDoctorProfileInfo,
  uploadClinicImage,
  submitServices,
  submitSpecialization,
  submitEducation,
  submitExperience,
  submitAwards,
  submitMemberships,
  submitRegistrations,
  updateDoctorProfileInfo,
  updateServices,
  updateSpecialization,
  updateEducation,
  updateExperience,
  updateAwards,
  updateMemberships,
  updateRegistrations,
  updateClinicImage,
  deleteClinicImage,
  deleteService,
  deleteSpecialization,
  deleteEducation,
  deleteExperience,
  deleteAward,
  deleteMembership,
  deleteRegistration,
  submitCoupon,
  updateCoupon,
  deleteCoupon,
} from "../../actions/doctorActions";
import {
  submitUpiDetails,
  updateUpiDetails,
  deleteUpi,
  submitBankDetails,
  updateBankDetails,
  deleteBank,
  getUpiDetails,
  getBankDetails,
} from "../../actions/bankDetailActions";
import MessageModal from "../Pages/MessageModel";
import { Link } from "react-router-dom";
const DoctorProfileForm = (props) => {
  const { selectedCurrency } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Please wait...");
  const { businessAddons, loading } = useSelector((state) => state.businessAddons);
  const [modalShow, setModalShow] = React.useState(false);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalMessage, setModalMessage] = React.useState("");
  const [modalVariant, setModalVariant] = React.useState("success");
  const hasActiveHomeAddon = businessAddons?.some(
  (addon) => addon.addon_name === "Home Visite" && addon.status?.toLowerCase() === "active"
);
  const hasActiveVideoAddon = businessAddons?.some(
  (addon) => addon.addon_name === "Video" && addon.status?.toLowerCase() === "active"
);

  const userList = useSelector((state) => state.loginReducer.userList || []);
  const dispatch = useDispatch();
  const DEFAULT_PROFILE_IMAGE = "/assets/img/defaultDoctorProfile.jpg";
  const DEFAULT_CLINIC_LOGO = "/assets/img/cliniclogo.png";
  const urlToFile = async (url, filename, mimeType) => {
    try {
      const res = await fetch(url);
      const buf = await res.arrayBuffer();
      return new File([buf], filename, { type: mimeType });
    } catch (error) {
      console.error("Image conversion error:", error);
      return null;
    }
  };
  
  // --- Get UPI and Bank details from dedicated reducers ---
  const { upiList: upisFromStore } = useSelector((state) => state.upiDetails);
  const { bankList: banksFromStore } = useSelector(
    (state) => state.bankDetails,
  );

  // --- Video Addon Access Check ---
  const [hasVideoAddonAccess, setHasVideoAddonAccess] = useState(false);
  const [videoAccessChecked, setVideoAccessChecked] = useState(false);
  const [checkingVideoAccess, setCheckingVideoAccess] = useState(true);

  useEffect(() => {
    props.getAllUsers(hospitalID);
    checkVideoAddonAccess();
  }, []);
  useEffect(() => {
    props.fetchSpecialities();
  }, []);

  // Check if video consultancy addon is available in active modules
  const checkVideoAddonAccess = async () => {
    try {
      const hospitalId = localStorage.getItem("hospitalCode");
      const userRole = localStorage.getItem("userRole");

      console.log(
        `[Video Addon Check] Hospital: ${hospitalId}, Role: ${userRole}`,
      );

      // For non-admin users, allow access by default (adjust as needed)
      if (userRole?.toLowerCase() !== "admin") {
        setHasVideoAddonAccess(true);
        setVideoAccessChecked(true);
        setCheckingVideoAccess(false);
        console.log("[Video Addon] Non-admin user - access granted by default");
        return;
      }

      if (!hospitalId) {
        console.log("[Video Addon] No hospital ID found");
        setHasVideoAddonAccess(false);
        setVideoAccessChecked(true);
        setCheckingVideoAccess(false);
        return;
      }

      // For admin users, check account status and active modules
      console.log("[Video Addon] Checking account status for admin user...");
      const accountStatus = await dispatch(getAccountStatus(hospitalId));

      console.log("[Video Addon] Account status:", accountStatus);

      // Check if video module is in active modules
      const hasVideoModule = accountStatus.activeModules.some(
        (module) =>
          module.module.toLowerCase().includes("video") ||
          module.module.toLowerCase().includes("consultancy") ||
          module.module.toLowerCase().includes("video consultancy"),
      );

      console.log(`[Video Addon] Video module found: ${hasVideoModule}`);
      console.log("[Video Addon] Active modules:", accountStatus.activeModules);

      setHasVideoAddonAccess(hasVideoModule);
      setVideoAccessChecked(true);
      setCheckingVideoAccess(false);
    } catch (error) {
      console.error("[Video Addon] Error checking account status:", error);
      // In case of error, restrict access for admin users
      const userRole = localStorage.getItem("userRole");
      setHasVideoAddonAccess(userRole?.toLowerCase() !== "admin");
      setVideoAccessChecked(true);
      setCheckingVideoAccess(false);
    }
  };

  // --- Helper function to determine and set a default primary payment if none is selected ---
  const getEffectivePrimaryPayment = () => {
    let effectivePrimaryPayment = { ...primaryPayment };

    if (effectivePrimaryPayment.type && effectivePrimaryPayment.uniqueId) {
      return effectivePrimaryPayment;
    }
    const firstUpiIndex = upiList.findIndex(
      (u) => u.upiId && u.upiId.trim() !== "",
    );
    if (firstUpiIndex !== -1) {
      const upi = upiList[firstUpiIndex];
      return { type: "upi", uniqueId: `upi-${upi.id || firstUpiIndex}` };
    }
    const firstBankIndex = bankList.findIndex(
      (b) => b.account_number && b.account_number.trim() !== "",
    );
    if (firstBankIndex !== -1) {
      const bank = bankList[firstBankIndex];
      return { type: "bank", uniqueId: `bank-${bank.id || firstBankIndex}` };
    }
    return effectivePrimaryPayment;
  };

  // ******** BANK DETAIL STATES ********
  const [paymentOption, setPaymentOption] = useState("upi");
  const [upiList, setUpiList] = useState([{ id: null, upiId: "" }]);
  const [bankList, setBankList] = useState([
    { id: null, beneficiary_name: "", account_number: "", ifsc_code: "" },
  ]);
  const [primaryPayment, setPrimaryPayment] = useState({
    type: "",
    uniqueId: null,
  });

  // --- Handlers for Multiple Bank Details ---
  const handlePaymentListChange = (index, event, list, setList) => {
    const { name, value } = event.target;
    const updatedList = [...list];
    updatedList[index][name] = value;
    setList(updatedList);
  };

  const addUpi = () => setUpiList([...upiList, { id: null, upiId: "" }]);
  const removeUpi = async (index) => {
    const upiToRemove = upiList[index];
    if (upiToRemove.id) {
      await dispatch(deleteUpi(upiToRemove.id, hospitalID));
    }
    setUpiList(upiList.filter((_, i) => i !== index));
  };

  const addBank = () =>
    setBankList([
      ...bankList,
      { id: null, beneficiary_name: "", account_number: "", ifsc_code: "" },
    ]);
  const removeBank = async (index) => {
    const bankToRemove = bankList[index];
    if (bankToRemove.id) {
      await dispatch(deleteBank(bankToRemove.id, hospitalID));
    }
    setBankList(bankList.filter((_, i) => i !== index));
  };

  const handleSetPrimary = (type, uniqueId) => {
    setPrimaryPayment({ type, uniqueId });
  };
  const handleRemovePhoto = () => {
    setUploadPhoto(null); // Setting to null indicates "removed"
    setPreviewUrl(DEFAULT_PROFILE_IMAGE);
  };
  const handleRemoveLogo = () => {
    setClinicLogo(null);
    setLogoPreviewUrl(DEFAULT_CLINIC_LOGO);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!hasVideoAddonAccess && videoConsultancyOption === "set_video_price") {
      setModalTitle("Access Denied");
      setModalMessage(
        "Please subscribe to the Video Consultancy Addon to enable this feature.",
      );
      setModalVariant("warning");
      setModalShow(true);
      return;
    }

    setIsLoading(true);
    setLoadingMessage("Creating profile..");

    const effectivePrimaryPayment = getEffectivePrimaryPayment();
    const online = clinicStatus ? (onlinePrice || "0") : "0";
    const offline = clinicStatus ? (offlinePrice || "0") : "0";
    const videoPriceToSend = videoStatus ? (videoConsultancyPrice || "0") : "0";
    const homeVisitOnlineToSend = homeStatus ? (homeVisitPriceOnline || "0") : "0";
    const homeVisitOfflineToSend = homeStatus ? (homeVisitPriceOffline || "0") : "0";
    const formData = new FormData();

    if (uploadPhoto instanceof File) {
      formData.append("uploadPhoto", uploadPhoto);
    } else {
      const defaultFile = await urlToFile(
        DEFAULT_PROFILE_IMAGE,
        "default_doctor.jpg",
        "image/jpeg",
      );
      if (defaultFile) formData.append("uploadPhoto", defaultFile);
    }

    if (ClinicLogo instanceof File) {
      formData.append("ClinicLogo", ClinicLogo);
    } else {
      // Add this else block to handle the default logo
      const defaultLogo = await urlToFile(
        DEFAULT_CLINIC_LOGO,
        "default_clinic.png",
        "image/png",
      );
      if (defaultLogo) formData.append("ClinicLogo", defaultLogo);
    }
    formData.append("username", username);
    formData.append("email", email);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("phoneNumber", phoneNumber);
    formData.append("gender", gender);
    formData.append("dateOfBirth", dateOfBirth);
    formData.append("aboutMe", aboutMe);
    formData.append("hospitalID", hospitalID);

    formData.append("ClinicInfoName", ClinicInfoName);
    formData.append("ClinicInfoAddress", ClinicInfoAddress);
    formData.append("CDAddressLine1", CDAddressLine1);
    formData.append("CDAddressLine2", CDAddressLine2);
    formData.append("CDCity", CDCity);
    formData.append("CDState", CDState);
    formData.append("CDCountry", CDCountry);
    formData.append("CDPostalCode", CDPostalCode);
    formData.append("primaryPaymentMethod", effectivePrimaryPayment.type);
   formData.append("PricingOnline", online);
formData.append("PricingOffline", offline);
formData.append("PricingVideo", videoPriceToSend);
formData.append("HomeVisitPricingOnline", homeVisitOnlineToSend);
formData.append("HomeVisitPricingOffline", homeVisitOfflineToSend);
formData.append("Home_status", (hasActiveHomeAddon && homeStatus) ? "1" : "0");
    formData.append("video_status", (hasActiveVideoAddon && videoStatus) ? "1" : "0");
    const pincodeStrings = pincodeList
      .map((p) => p.pincode)
      .filter((p) => p.trim() !== ""); // Khali pincodes hata dein

    // 2. FormData mein append karein
    formData.append("Clinic_status", clinicStatus ? "1" : "0");
    formData.append("Home_status", homeStatus ? "1" : "0");
    formData.append("video_status", videoStatus ? "1" : "0");

    // Pincodes ko JSON string bhej rahe hain kyunki ye ek array hai
    formData.append("pincodes", JSON.stringify(pincodeStrings));
    const userData = {
      hospitalID,
      username,
      first_name: firstName,
      last_name: lastName,
      email,
      mobile: phoneNumber,
    };

    try {
      await dispatch(updateUser(userData));
      await dispatch(submitDoctorProfileInfo(formData));

      if (clinicImages && clinicImages.length > 0) {
        for (const climg of clinicImages) {
          const fileToUpload =
            climg instanceof File ? climg : climg?.file || climg?.image;
          if (!fileToUpload) continue;
          const imgData = new FormData();
          imgData.append("hospitalID", hospitalID);
          imgData.append("ClinicImage", fileToUpload);
          await dispatch(uploadClinicImage(imgData));
        }
      }

      for (const [index, upi] of upiList.entries()) {
        if (upi.upiId?.trim()) {
          await dispatch(
            submitUpiDetails({
              vpa: upi.upiId,
              is_primary: effectivePrimaryPayment.uniqueId === `upi-${index}`,
              hospitalID,
            }),
          );
        }
      }
      for (const [index, bank] of bankList.entries()) {
        if (bank.account_number?.trim()) {
          await dispatch(
            submitBankDetails({
              ...bank,
              is_primary: effectivePrimaryPayment.uniqueId === `bank-${index}`,
              hospitalID,
            }),
          );
        }
      }

      if (services.length > 0)
        for (const ser of services)
          await dispatch(submitServices({ Services: ser.service, hospitalID }));
      if (specialization.length > 0)
        for (const spec of specialization)
          await dispatch(
            submitSpecialization({
              Specialization: spec.specialization,
              hospitalID,
            }),
          );
      for (const edu of educationList)
        if (edu.degree) await dispatch(submitEducation({ ...edu, hospitalID }));
      for (const exp of experienceList)
        if (exp.hospital)
          await dispatch(submitExperience({ ...exp, hospitalID }));
      for (const award of awardsList)
        if (award.award) await dispatch(submitAwards({ ...award, hospitalID }));

      setModalTitle("Success");
      setModalMessage("Profile Created Successfully!");
      setModalVariant("success");
      setModalShow(true);
      dispatch(getDoctorProfileById(hospitalID));
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to create profile.");
      setModalVariant("danger");
      setModalShow(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEdit = async (event) => {
    event.preventDefault();

    if (!hasVideoAddonAccess && videoConsultancyOption === "set_video_price") {
      setModalTitle("Access Denied");
      setModalMessage("Video consultancy access is required to set a price.");
      setModalVariant("warning");
      setModalShow(true);
      return;
    }

    setIsLoading(true);
    setLoadingMessage("Updating profile information...");
    const effectivePrimaryPayment = getEffectivePrimaryPayment();

    
    const waitingToSend =
      waitingOption === "no_waiting" ? "0" : waitingTime || "0";
    // logic for Clinic
    
const online = clinicStatus ? (onlinePrice || "0") : "0";
const offline = clinicStatus ? (offlinePrice || "0") : "0";

// logic for Video (Radio option hata kar direct status check)
const finalVideoStatus = (hasActiveVideoAddon && videoStatus) ? "1" : "0";
const videoPriceToSend = videoStatus ? (videoConsultancyPrice || "0") : "0";

// logic for Home Visit (Radio option hata kar direct status check)
 const finalHomeStatus = (hasActiveHomeAddon && homeStatus) ? "1" : "0";
const homeVisitOnlineToSend = homeStatus ? (homeVisitPriceOnline || "0") : "0";
const homeVisitOfflineToSend = homeStatus ? (homeVisitPriceOffline || "0") : "0";
    const formData = new FormData();
    formData.append("id", profileData.id);

    if (uploadPhoto instanceof File) {
      formData.append("uploadPhoto", uploadPhoto);
    } else if (typeof uploadPhoto === "string" && uploadPhoto !== "") {
      // Yeh line missing thi: Existing image path ko wapis bhejें taaki backend use delete na kare
      formData.append("uploadPhoto", uploadPhoto);
    } else if (uploadPhoto === null || uploadPhoto === "") {
      const defaultFile = await urlToFile(
        DEFAULT_PROFILE_IMAGE,
        "default_doctor.jpg",
        "image/jpeg",
      );
      if (defaultFile) formData.append("uploadPhoto", defaultFile);
    }
    if (ClinicLogo instanceof File) {
      formData.append("ClinicLogo", ClinicLogo);
    } else if (typeof ClinicLogo === "string" && ClinicLogo !== "") {
      // Existing logo string ko bhejें
      formData.append("ClinicLogo", ClinicLogo);
    } else if (ClinicLogo === null || !ClinicLogo) {
      const defaultLogo = await urlToFile(
        DEFAULT_CLINIC_LOGO,
        "default_clinic.png",
        "image/png",
      );
      if (defaultLogo) formData.append("ClinicLogo", defaultLogo);
    }

    formData.append("username", username);
    formData.append("email", email);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("phoneNumber", phoneNumber);
    formData.append("gender", gender);
    formData.append("dateOfBirth", dateOfBirth);
    formData.append("aboutMe", aboutMe);
    formData.append("hospitalID", hospitalID);

    formData.append("ClinicInfoName", ClinicInfoName);
    formData.append("ClinicInfoAddress", ClinicInfoAddress);
    formData.append("CDAddressLine1", CDAddressLine1);
    formData.append("CDAddressLine2", CDAddressLine2);
    formData.append("CDCity", CDCity);
    formData.append("CDState", CDState);
    formData.append("CDCountry", CDCountry);
    formData.append("CDPostalCode", CDPostalCode);
    formData.append("WaitingTime", waitingToSend);
    formData.append("PriPaymentMethod", effectivePrimaryPayment.type);
    formData.append("PricingOnline", online);
formData.append("PricingOffline", offline);
formData.append("PricingVideo", videoPriceToSend);
formData.append("HomeVisitPricingOnline", homeVisitOnlineToSend);
formData.append("HomeVisitPricingOffline", homeVisitOfflineToSend);
    // 1. Pincodes ko array of strings mein convert karein
    const pincodeStrings = pincodeList
      .map((p) => p.pincode)
      .filter((p) => p.trim() !== ""); // Khali pincodes hata dein

    // 2. FormData mein append karein
    formData.append("Clinic_status", clinicStatus ? "1" : "0");
    formData.append("Home_status", homeStatus ? "1" : "0");
    formData.append("video_status", videoStatus ? "1" : "0");

    // Pincodes ko JSON string bhej rahe hain kyunki ye ek array hai
    formData.append("pincodes", JSON.stringify(pincodeStrings));
    const userData = {
      hospitalID,
      username,
      first_name: firstName,
      last_name: lastName,
      email,
      mobile: phoneNumber,
    };

    try {
      await dispatch(updateUser(userData));
      await dispatch(updateDoctorProfileInfo(formData));

      if (clinicImages && clinicImages.length > 0) {
        for (const climg of clinicImages) {
          if (
            !climg.file &&
            !(climg instanceof File) &&
            !(climg.image instanceof File)
          )
            continue;
          const imgData = new FormData();
          imgData.append("hospitalID", hospitalID);
          if (climg.id) imgData.append("id", climg.id);
          let fileToUpload =
            climg instanceof File ? climg : climg.file || climg.image;
          if (fileToUpload) {
            imgData.append("ClinicImage", fileToUpload);
            if (climg.id) await dispatch(updateClinicImage(imgData));
            else await dispatch(uploadClinicImage(imgData));
          }
        }
      }

      for (const [index, upi] of upiList.entries()) {
        if (upi.upiId && upi.upiId.trim() !== "") {
          const uniqueId = `upi-${upi.id || index}`;
          const upiData = {
            id: upi.id,
            hospitalID,
            vpa: upi.upiId,
            is_primary: effectivePrimaryPayment.uniqueId === uniqueId,
          };
          if (upi.id) await dispatch(updateUpiDetails(upiData));
          else await dispatch(submitUpiDetails(upiData));
        }
      }
      for (const [index, bank] of bankList.entries()) {
        if (bank.account_number && bank.account_number.trim() !== "") {
          const uniqueId = `bank-${bank.id || index}`;
          const bankData = {
            id: bank.id,
            hospitalID,
            beneficiary_name: bank.beneficiary_name,
            account_number: bank.account_number,
            ifsc_code: bank.ifsc_code,
            is_primary: effectivePrimaryPayment.uniqueId === uniqueId,
          };
          if (bank.id) await dispatch(updateBankDetails(bankData));
          else await dispatch(submitBankDetails(bankData));
        }
      }

      for (const ser of services) {
        const serviceData = {
          id: ser.id || null,
          Services: ser.service || ser,
          hospitalID,
        };
        if (serviceData.id) await dispatch(updateServices(serviceData));
        else await dispatch(submitServices(serviceData));
      }
      for (const spec of specialization) {
        const specData = {
          id: spec.id || null,
          Specialization: spec.specialization || spec,
          hospitalID,
        };
        if (specData.id) await dispatch(updateSpecialization(specData));
        else await dispatch(submitSpecialization(specData));
      }

      for (const edu of educationList) {
        if (edu.degree || edu.college || edu.year) {
          const eduData = {
            id: edu.id || null,
            Degree: edu.degree,
            CollegeInst: edu.college,
            YearofCompl: edu.year,
            hospitalID,
          };
          if (eduData.id) await dispatch(updateEducation(eduData));
          else await dispatch(submitEducation(eduData));
        }
      }
      for (const exp of experienceList) {
        if (exp.hospital || exp.designation) {
          const expData = {
            id: exp.id || null,
            HospitalName: exp.hospital,
            ExpFrom: exp.from,
            ExpTo: exp.to,
            Designation: exp.designation,
            hospitalID,
          };
          if (expData.id) await dispatch(updateExperience(expData));
          else await dispatch(submitExperience(expData));
        }
      }
      for (const coupon of couponList) {
 
  if (coupon.CouponName || coupon.DiscountPercent) {
    const couponData = {
      id: coupon.id || null, 
      hospitalID: hospitalID,
      CouponName: coupon.CouponName,
      DiscountPercent: coupon.DiscountPercent,
      StartDate: coupon.StartDate,
      EndDate: coupon.EndDate,
    };

    if (couponData.id) {
     
      await dispatch(updateCoupon(couponData));
    } else {
    
      await dispatch(submitCoupon(couponData));
    }
  }
}
      setModalTitle("Success");
      setModalMessage("Profile Updated Successfully!");
      setModalVariant("success");
      setModalShow(true);
      dispatch(getDoctorProfileById(hospitalID));
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to update profile.");
      setModalVariant("danger");
      setModalShow(true);
    } finally {
      setIsLoading(false);
    }
  };
  const hospitalID = parseInt(localStorage.getItem("hospitalCode"), 10);
  const [uploadPhoto, setUploadPhoto] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [ClinicLogo, setClinicLogo] = useState(null);
  const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);

  useEffect(() => {
    if (uploadPhoto instanceof File) {
      const objectUrl = URL.createObjectURL(uploadPhoto);
      setPreviewUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else if (typeof uploadPhoto === "string") {
      setPreviewUrl(uploadPhoto);
    }
  }, [uploadPhoto]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];

    if (
      file &&
      file.size <= 2 * 1024 * 1024 &&
      validTypes.includes(file.type)
    ) {
      setUploadPhoto(file);
    } else {
      setUploadPhoto("");
      alert("Image must be JPG, PNG, or GIF and under 2MB.");
    }
  };

  useEffect(() => {
    if (ClinicLogo instanceof File) {
      const objectUrl = URL.createObjectURL(ClinicLogo);
      setLogoPreviewUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else if (typeof ClinicLogo === "string" && ClinicLogo) {
      setLogoPreviewUrl(`${imgUrl}${ClinicLogo}`);
    } else {
      setLogoPreviewUrl(null);
    }
  }, [ClinicLogo]);
  useEffect(() => {
    if (hospitalID) {
        dispatch(getBusinessAddons({ hospitalID: hospitalID }));
    }
}, [dispatch, hospitalID]);

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    const validTypes = ["image/jpeg", "image/png", "image/gif"];
    const maxSize = 2 * 1024 * 1024;

    if (file && validTypes.includes(file.type) && file.size <= maxSize) {
      setClinicLogo(file);
    } else {
      setClinicLogo(null);
      alert("Logo must be a JPG, PNG, or GIF file and must be under 2MB.");
    }
  };
  // --- Naye Status States ---
  const [clinicStatus, setClinicStatus] = useState(false);
  const [homeStatus, setHomeStatus] = useState(false);
  const [videoStatus, setVideoStatus] = useState(false);

  // --- Pincode State ---
  const [pincodeList, setPincodeList] = useState([{ id: null, pincode: "" }]);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [gender, setGender] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [aboutMe, setaboutMe] = useState("");
  const [clinicImages, setClinicImages] = useState([]);
  const [ClinicInfoName, setClinicInfoName] = useState("");
  const [ClinicInfoAddress, setClinicInfoAddress] = useState("");
  const [CDAddressLine1, setCDAddressLine1] = useState("");
  const [CDAddressLine2, setCDAddressLine2] = useState("");
  const [CDCity, setCDCity] = useState("");
  const [CDState, setCDState] = useState("");
  const [CDPostalCode, setCDPostalCode] = useState("");
  const [CDCountry, setCDCountry] = useState("");
  const [videoConsultancyOption, setVideoConsultancyOption] =
    useState("no_video");
  const [videoConsultancyPrice, setVideoConsultancyPrice] = useState("");
  const [homeVisitOption, setHomeVisitOption] = useState("no_home_visit");
  const [homeVisitPriceOnline, setHomeVisitPriceOnline] = useState("");
  const [homeVisitPriceOffline, setHomeVisitPriceOffline] = useState("");
  const [educationList, setEducationList] = useState([
    { degree: "", college: "", year: "" },
  ]);
  const [experienceList, setExperienceList] = useState([
    { hospital: "", from: "", to: "", designation: "" },
  ]);
  const [awardsList, setAwardsList] = useState([{ award: "", year: "" }]);
  const [membershipList, setMembershipList] = useState([
    { membership: "", year: "" },
  ]);
  const [registrationList, setRegistrationList] = useState([
    { registration: "", year: "" },
  ]);

  // Handle video consultancy option change with access check
  const handleVideoOptionChange = (option) => {
    if (option === "set_video_price" && !hasVideoAddonAccess) {
      setModalTitle("Access Denied");
      setModalMessage(
        "Video consultancy feature is not available. Please subscribe to the Video Consultancy Addon Package to enable this feature.",
      );
      setModalVariant("warning");
      setModalShow(true);
      return;
    }
    setVideoConsultancyOption(option);
  };

  // Handle video price change with access check
  const handleVideoPriceChange = (price) => {
    if (!hasVideoAddonAccess) {
      setModalTitle("Access Denied");
      setModalMessage(
        "Video consultancy feature is not available. Please subscribe to the Video Consultancy Addon Package to set video consultation prices.",
      );
      setModalVariant("warning");
      setModalShow(true);
      return;
    }
    setVideoConsultancyPrice(price);
  };

  // Rest of your existing handlers remain the same...
  const handleEducationChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...educationList];
    list[index][name] = value;
    setEducationList(list);
  };
  const addEducation = () => {
    setEducationList([...educationList, { degree: "", college: "", year: "" }]);
  };
  const removeEducation = async (index) => {
    const item = educationList[index];
    try {
      if (item.id) await dispatch(deleteEducation(item.id, hospitalID));
      setEducationList((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Education record removed successfully!");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove education.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };

  const handleExperienceChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...experienceList];
    list[index][name] = value;
    setExperienceList(list);
  };
  const addExperience = () => {
    setExperienceList([
      ...experienceList,
      { hospital: "", from: "", to: "", designation: "" },
    ]);
  };
  const removeExperience = async (index) => {
    const item = experienceList[index];
    try {
      if (item.id) await dispatch(deleteExperience(item.id, hospitalID));
      setExperienceList((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Experience record removed.");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove experience.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };

  const handleAwardsChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...awardsList];
    list[index][name] = value;
    setAwardsList(list);
  };
  const addAwards = () => {
    setAwardsList([...awardsList, { award: "", year: "" }]);
  };
  const removeAwards = async (index) => {
    const item = awardsList[index];
    try {
      if (item.id) await dispatch(deleteAward(item.id, hospitalID));
      setAwardsList((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Award record removed.");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove award.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };

  const handleMembershipChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...membershipList];
    list[index][name] = value;
    setMembershipList(list);
  };
  const addMembership = () => {
    setMembershipList([...membershipList, { membership: "", year: "" }]);
  };
  const removeMembership = async (index) => {
    const item = membershipList[index];
    try {
      if (item.id) await dispatch(deleteMembership(item.id, hospitalID));
      setMembershipList((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Membership record removed.");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove membership.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };
  const handlePincodeChange = (index, e) => {
    const { value } = e.target;
    const list = [...pincodeList];
    list[index].pincode = value;
    setPincodeList(list);
  };

  const addPincode = () => {
    setPincodeList([...pincodeList, { id: null, pincode: "" }]);
  };

  const removePincode = async (index) => {
    const item = pincodeList[index];
    // Agar backend se aaya hua pincode hai (id hai), toh delete action call karein (optional)
    // Filhaal hum sirf list se hata rahe hain
    const list = pincodeList.filter((_, i) => i !== index);
    setPincodeList(list.length > 0 ? list : [{ id: null, pincode: "" }]);
  };
  const handleRegistrationChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...registrationList];
    list[index][name] = value;
    setRegistrationList(list);
  };
  const addRegistration = () => {
    setRegistrationList([...registrationList, { registration: "", year: "" }]);
  };
  const removeRegistration = async (index) => {
    const item = registrationList[index];
    try {
      if (item.id) await dispatch(deleteRegistration(item.id, hospitalID));
      setRegistrationList((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Registration record removed.");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove registration.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };

  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setClinicImages((prev) => [...prev, ...newImages]);
  };
  const removeImage = async (index) => {
    const item = clinicImages[index];
    try {
      if (item.id) await dispatch(deleteClinicImage(item.id, hospitalID));
      setClinicImages((prevImages) => prevImages.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Clinic image removed.");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove image.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    const newImages = files
      .filter((file) => file.type.startsWith("image/"))
      .map((file) => ({ file, preview: URL.createObjectURL(file) }));
    setClinicImages((prev) => [...prev, ...newImages]);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleCouponChange = (index, e) => {
    const { name, value } = e.target;
    const list = [...couponList];
    list[index][name] = value;
    setCouponList(list);
  };

  const addCoupon = () => {
    setCouponList([
      ...couponList,
      {
        id: null,
        CouponName: "",
        DiscountPercent: "",
        StartDate: "",
        EndDate: "",
      },
    ]);
  };

  const removeCoupon = async (index) => {
    const item = couponList[index];
    try {
      if (item.id) {
        await dispatch(deleteCoupon(item.id, hospitalID));
        console.log("Dispatching delete for coupon ID:", item.id);
      }
      setCouponList((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Coupon removed successfully!");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove coupon.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };

  const [couponList, setCouponList] = useState([
    {
      id: null,
      CouponName: "",
      DiscountPercent: "",
      StartDate: "",
      EndDate: "",
    },
  ]);
  const [waitingOption, setWaitingOption] = useState("no_waiting");
  const [waitingTime, setWaitingTime] = useState("");
  const [priceOption, setPriceOption] = useState("price_free");
  const [onlinePrice, setOnlinePrice] = useState("");
  const [offlinePrice, setOfflinePrice] = useState("");
  const [services, setServices] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [serviceInput, setServiceInput] = useState("");
  const [specializationInput, setSpecializationInput] = useState("");

  const handleKeyPress = (e, type) => {
    if (e.key === "Enter" && e.target.value.trim()) {
      e.preventDefault();
      const value = e.target.value.trim();
      if (type === "service") {
        setServices([...services, { id: null, service: value }]);
        setServiceInput("");
      } else if (type === "specialization") {
        setSpecialization([
          ...specialization,
          { id: null, specialization: value },
        ]);
        setSpecializationInput("");
      }
    }
  };
  const handleRemoveService = async (index) => {
    const item = services[index];
    try {
      if (item.id) await dispatch(deleteService(item.id, hospitalID));
      setServices((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Service removed.");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove service.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };
  const handleRemoveSpecialization = async (index) => {
    const item = specialization[index];
    try {
      if (item.id) await dispatch(deleteSpecialization(item.id, hospitalID));
      setSpecialization((prev) => prev.filter((_, i) => i !== index));
      setModalTitle("Success");
      setModalMessage("Specialization removed.");
      setModalVariant("success");
      setModalShow(true);
    } catch (error) {
      setModalTitle("Error");
      setModalMessage("Failed to remove specialization.");
      setModalVariant("danger");
      setModalShow(true);
    }
  };

  useEffect(() => {
    if (hospitalID) {
      dispatch(getDoctorProfileById(hospitalID));
      dispatch(getUpiDetails(hospitalID));
      dispatch(getBankDetails(hospitalID));
    }
  }, [dispatch, hospitalID]);

  const profileData = useSelector((state) => state.doctorProfile.profileData);

  useEffect(() => {
    if (profileData) {
      // Images: Agar data nahi hai toh null set karein
      setUploadPhoto(profileData.uploadPhoto || null);
      setClinicLogo(profileData.ClinicLogo || null);

      // Basic Info
      setUsername(profileData.username || "");
      setEmail(profileData.email || "");
      setFirstName(profileData.firstName || "");
      setLastName(profileData.lastName || "");
      setPhoneNumber(profileData.phoneNumber || "");
      setGender(profileData.gender || "");
      setDateOfBirth(profileData.dateOfBirth || "");
      setaboutMe(profileData.aboutMe || "");
      // 1. STATUS SET KARNA (Boolean mein convert karke)
      const isClinicActive =
        profileData.Clinic_status == "1" || profileData.Clinic_status === true;
      const isHomeActive =
        profileData.Home_status == "1" || profileData.Home_status === true;
      const isVideoActive =
        profileData.video_status == "1" || profileData.video_status === true;

      setClinicStatus(isClinicActive);
      setHomeStatus(isHomeActive);
      setVideoStatus(isVideoActive);

      // 2. CLINIC PRICING LOGIC
      if (
        isClinicActive &&
        (profileData.PricingOnline > 0 || profileData.PricingOffline > 0)
      ) {
        setPriceOption("custom_price");
        setOnlinePrice(profileData.PricingOnline || "");
        setOfflinePrice(profileData.PricingOffline || "");
      } else {
        setPriceOption("price_free");
        setOnlinePrice("");
        setOfflinePrice("");
      }

      // 3. VIDEO PRICING LOGIC
      if (
        isVideoActive &&
        profileData.PricingVideo &&
        parseFloat(profileData.PricingVideo) > 0
      ) {
        setVideoConsultancyOption("set_video_price");
        setVideoConsultancyPrice(profileData.PricingVideo);
      } else {
        setVideoConsultancyOption("no_video");
        setVideoConsultancyPrice("");
      }

      // 4. HOME VISIT + PINCODE LOGIC
      if (isHomeActive) {
        // Load Pincodes
        if (
          Array.isArray(profileData.Pincodes) &&
          profileData.Pincodes.length > 0
        ) {
          setPincodeList(
            profileData.Pincodes.map((p) => ({ id: p.id, pincode: p.pincode })),
          );
        } else {
          setPincodeList([{ id: null, pincode: "" }]);
        }
        // Load Home Prices
        if (
          parseFloat(profileData.HomeVisitPricingOnline) > 0 ||
          parseFloat(profileData.HomeVisitPricingOffline) > 0
        ) {
          setHomeVisitOption("set_home_visit_price");
          setHomeVisitPriceOnline(profileData.HomeVisitPricingOnline || "");
          setHomeVisitPriceOffline(profileData.HomeVisitPricingOffline || "");
        }
      } else {
        // Agar Home status 0 hai toh sab reset
        setPincodeList([{ id: null, pincode: "" }]);
        setHomeVisitOption("no_home_visit");
        setHomeVisitPriceOnline("");
        setHomeVisitPriceOffline("");
      }
      // Clinic Info
      setClinicInfoName(profileData.ClinicInfoName || "");
      setClinicInfoAddress(profileData.ClinicInfoAddress || "");
      setCDAddressLine1(profileData.CDAddressLine1 || "");
      setCDAddressLine2(profileData.CDAddressLine2 || "");
      setCDCity(profileData.CDCity || "");
      setCDState(profileData.CDState || "");
      setCDCountry(profileData.CDCountry || "");
      setCDPostalCode(profileData.CDPostalCode || "");

      // Video & Home Visit Pricing
      if (
        profileData.PricingVideo &&
        parseFloat(profileData.PricingVideo) > 0
      ) {
        setVideoConsultancyOption("set_video_price");
        setVideoConsultancyPrice(profileData.PricingVideo);
      } else {
        setVideoConsultancyOption("no_video");
        setVideoConsultancyPrice("");
      }

      if (
        (profileData.HomeVisitPricingOnline &&
          parseFloat(profileData.HomeVisitPricingOnline) > 0) ||
        (profileData.HomeVisitPricingOffline &&
          parseFloat(profileData.HomeVisitPricingOffline) > 0)
      ) {
        setHomeVisitOption("set_home_visit_price");
        setHomeVisitPriceOnline(profileData.HomeVisitPricingOnline || "");
        setHomeVisitPriceOffline(profileData.HomeVisitPricingOffline || "");
      } else {
        setHomeVisitOption("no_home_visit");
        setHomeVisitPriceOnline("");
        setHomeVisitPriceOffline("");
      }

      // Gallery Images
      if (Array.isArray(profileData.ClinicImages)) {
        setClinicImages(
          profileData.ClinicImages.map((img) => ({
            id: img.id,
            url: img.ClinicImage,
            preview: img.ClinicImage,
            file: null,
          })),
        );
      } else {
        setClinicImages([]);
      }

      // Nested Arrays (Services, Specialization, etc.)
      setServices(
        Array.isArray(profileData.Services)
          ? profileData.Services.map((s) => ({ id: s.id, service: s.Services }))
          : [],
      );
      setSpecialization(
        Array.isArray(profileData.Specializations)
          ? profileData.Specializations.map((s) => ({
              id: s.id,
              specialization: s.Specialization,
            }))
          : [],
      );

      setEducationList(
        Array.isArray(profileData.Educations) &&
          profileData.Educations.length > 0
          ? profileData.Educations.map((e) => ({
              id: e.id,
              degree: e.Degree,
              college: e.CollegeInst,
              year: e.YearofCompl,
            }))
          : [{ degree: "", college: "", year: "" }],
      );

      setExperienceList(
        Array.isArray(profileData.Experiences) &&
          profileData.Experiences.length > 0
          ? profileData.Experiences.map((exp) => ({
              id: exp.id,
              hospital: exp.HospitalName,
              from: exp.ExpFrom,
              to: exp.ExpTo,
              designation: exp.Designation,
            }))
          : [{ hospital: "", from: "", to: "", designation: "" }],
      );

      setAwardsList(
        Array.isArray(profileData.Awards) && profileData.Awards.length > 0
          ? profileData.Awards.map((a) => ({
              id: a.id,
              award: a.Awards,
              year: a.Year,
            }))
          : [{ award: "", year: "" }],
      );

      setMembershipList(
        Array.isArray(profileData.Memberships) &&
          profileData.Memberships.length > 0
          ? profileData.Memberships.map((m) => ({
              id: m.id,
              membership: m.Memberships,
              year: m.MYear,
            }))
          : [{ membership: "", year: "" }],
      );

      setRegistrationList(
        Array.isArray(profileData.Registrations) &&
          profileData.Registrations.length > 0
          ? profileData.Registrations.map((r) => ({
              id: r.id,
              registration: r.Registrations,
              year: r.Year,
            }))
          : [{ registration: "", year: "" }],
      );

      // Pricing & Coupons
      if (profileData.PricingOnline > 0 || profileData.PricingOffline > 0) {
        setPriceOption("custom_price");
        setOnlinePrice(profileData.PricingOnline || "");
        setOfflinePrice(profileData.PricingOffline || "");
      } else {
        setPriceOption("price_free");
      }

      setCouponList(
        Array.isArray(profileData.Coupons) && profileData.Coupons.length > 0
          ? profileData.Coupons.map((c) => ({
              id: c.id,
              CouponName: c.CouponName || "",
              DiscountPercent: c.DiscountPercent || "",
              StartDate: c.StartDate ? c.StartDate.split("T")[0] : "",
              EndDate: c.EndDate ? c.EndDate.split("T")[0] : "",
            }))
          : [
              {
                id: null,
                CouponName: "",
                DiscountPercent: "",
                StartDate: "",
                EndDate: "",
              },
            ],
      );
    }
  }, [profileData]);
  useEffect(() => {
    if (upisFromStore && upisFromStore.length > 0) {
      let primaryFound = false;
      const formattedUpis = upisFromStore.map((upi, index) => {
        if (upi.is_primary) {
          const uniqueId = `upi-${upi.id || index}`;
          setPrimaryPayment({ type: "upi", uniqueId });
          setPaymentOption("upi");
          primaryFound = true;
        }
        return { id: upi.id, upiId: upi.vpa };
      });
      setUpiList(formattedUpis);
    } else {
      setUpiList([{ id: null, upiId: "" }]);
    }
  }, [upisFromStore]);

  useEffect(() => {
    if (banksFromStore && banksFromStore.length > 0) {
      let primaryFound = false;
      const formattedBanks = banksFromStore.map((bank, index) => {
        if (bank.is_primary) {
          const uniqueId = `bank-${bank.id || index}`;
          setPrimaryPayment({ type: "bank", uniqueId });
          setPaymentOption("bank");
          primaryFound = true;
        }
        return {
          id: bank.id,
          beneficiary_name: bank.beneficiary_name,
          account_number: bank.account_number,
          ifsc_code: bank.ifsc_code,
        };
      });
      setBankList(formattedBanks);
    } else {
      setBankList([
        { id: null, beneficiary_name: "", account_number: "", ifsc_code: "" },
      ]);
    }
  }, [banksFromStore]);

useEffect(() => {
  if (!hasActiveVideoAddon) {
    setVideoStatus(false);
  } 
  if (!hasActiveHomeAddon) {
    setHomeStatus(false);
  }
}, [hasActiveVideoAddon, hasActiveHomeAddon]);
  useEffect(() => {
    if (userList.length > 0) {
      const user = userList.find((u) => u.hospitalID === hospitalID);
      if (user && (!profileData || !profileData.firstName)) {
        console.log("Setting pre-filled data from User Table...");
        if (user.username) setUsername(user.username);
        if (user.first_name) setFirstName(user.first_name);
        if (user.last_name) setLastName(user.last_name);
        if (user.mobile) setPhoneNumber(user.mobile);
        if (user.email) setEmail(user.email);
      }
    }
  }, [userList, hospitalID, profileData]);
  return (
    <div>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "8px",
              textAlign: "center",
              boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            }}
          >
            <div className="spinner-border text-primary" role="status" />
            <p className="mt-3">{loadingMessage}</p>
          </div>
        </div>
      )}

      {/* Show loading while checking video access */}
      {checkingVideoAccess && (
        <div className="alert alert-info text-center">
          <div
            className="spinner-border spinner-border-sm me-2"
            role="status"
          />
          Checking video consultancy access permissions...
        </div>
      )}

      {/* Show access warning for video consultancy */}
      {!hasVideoAddonAccess && videoAccessChecked && (
        <div className="alert alert-warning">
          <i className="fas fa-video-slash me-2"></i>
          <strong>Video Consultancy Feature Not Available</strong>
          <p className="mb-0 mt-1">
            The video consultancy feature requires the Video Consultancy Addon
            Package. Please subscribe to this addon to enable video consultation
            services.
          </p>
        </div>
      )}
      <div className="page-header filter-bar rounded ">
        <div className="row align-items-center">
          <div className="col">
            <h4 className="page-title">Profile-settings</h4>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/doctor/dashboard">Doctor Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">Profile-settings</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="row form-row">
            <div className="col-md-12">
              <div className="form-group">
                <div className="change-avatar">
                  <div className="profile-img">
                    <img
                      src={
                        uploadPhoto instanceof File
                          ? URL.createObjectURL(uploadPhoto) // Jab user nayi image select kare
                          : uploadPhoto &&
                              typeof uploadPhoto === "string" &&
                              uploadPhoto !== ""
                            ? uploadPhoto.startsWith("blob:")
                              ? uploadPhoto
                              : `${imgUrl}${uploadPhoto}` // Database se aayi image
                            : DEFAULT_PROFILE_IMAGE // Agar image null ho toh default placeholder
                      }
                      alt="User"
                      style={{
                        width: "110px",
                        height: "110px",
                        objectFit: "cover",
                        borderRadius: "8%",
                      }}
                      onError={(e) => {
                        e.target.src = DEFAULT_PROFILE_IMAGE;
                      }} // Fallback agar image path galat ho
                    />
                  </div>
                  <div className="upload-img">
                    <div>
                      <button
                        type="button"
                        className="btn btn-info rounded-pill mb-2"
                        onClick={() =>
                          document.getElementById("upload-photo").click()
                        }
                      >
                        Upload Photo
                      </button>

                      <input
                        id="upload-photo"
                        type="file"
                        className="upload"
                        accept="image/*"
                        onChange={handleImageChange}
                        hidden
                      />
                    </div>

                    {/* REMOVE BUTTON LOGIC: Jab image placeholder nahi hai tabhi dikhayein */}
                    {uploadPhoto && uploadPhoto !== "" && (
                      <button
                        type="button"
                        className="btn btn-danger rounded-pill d-block mt-1"
                        onClick={handleRemovePhoto}
                        style={{ fontSize: "12px", padding: "5px 15px" }}
                      >
                        Remove Photo
                      </button>
                    )}

                    <small className="form-text text-muted">
                      Allowed JPG, GIF or PNG. Max 2MB.
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>
                  Username <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Email </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>
                  First Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>
                  Last Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  className="form-control"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Gender</label>
                <select
                  className="form-control select"
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group mb-0">
                <label>Date of Birth</label>
                <input
                  type="date"
                  className="form-control"
                  value={dateOfBirth}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h4 className="card-title">About Me</h4>
          <div className="form-group mb-0">
            <label>Biography</label>
            <textarea
              className="form-control"
              rows={10}
              style={{ minHeight: "250px", resize: "vertical" }}
              placeholder="Write about yourself..."
              value={aboutMe}
              onChange={(e) => setaboutMe(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Clinic Info Card (unchanged) */}
      <div className="card shadow-sm border-0 my-4">
        <div className="card-header bg-white py-3">
          <h4 className="mb-0">Clinic Info</h4>
        </div>
        <div className="card-body p-4">
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Clinic Name</label>
              <input
                type="text"
                className="form-control"
                value={ClinicInfoName}
                onChange={(e) => setClinicInfoName(e.target.value)}
                placeholder="Enter the official name of your clinic"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Clinic Address</label>
              <input
                type="text"
                className="form-control"
                value={ClinicInfoAddress}
                onChange={(e) => setClinicInfoAddress(e.target.value)}
                placeholder="e.g., 123 Health St, Wellness City"
              />
            </div>
          </div>

          <hr className="my-4" />

          <div className="row">
            <div className="col-md-6 mb-4">
              <label className="form-label d-block">Clinic Logo</label>
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <img
                    src={
                      ClinicLogo instanceof File
                        ? URL.createObjectURL(ClinicLogo) // Naya selection
                        : ClinicLogo &&
                            typeof ClinicLogo === "string" &&
                            ClinicLogo !== ""
                          ? ClinicLogo.startsWith("blob:")
                            ? ClinicLogo
                            : `${imgUrl}${ClinicLogo}` // Database se aaya logo
                          : DEFAULT_CLINIC_LOGO // Default logo
                    }
                    alt="Clinic Logo Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                      border: "1px solid #ddd",
                    }}
                    onError={(e) => {
                      e.target.src = DEFAULT_CLINIC_LOGO;
                    }}
                  />
                </div>
                <div className="d-flex flex-column" style={{ gap: "8px" }}>
                  <div className="btn btn-info rounded-pill position-relative">
                    <span>Upload Logo</span>
                    <input
                      type="file"
                      className="upload-button"
                      accept="image/*"
                      onChange={handleLogoChange}
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        opacity: 0,
                        cursor: "pointer",
                      }}
                    />
                  </div>

                  {/* REMOVE LOGO LOGIC */}
                  {ClinicLogo && ClinicLogo !== "" && (
                    <button
                      type="button"
                      className="btn btn-danger rounded-pill d-block mt-1"
                      onClick={handleRemoveLogo}
                      style={{ fontSize: "12px", padding: "5px 15px" }}
                    >
                      Remove Logo
                    </button>
                  )}

                  <small className="form-text text-muted">
                    JPG, PNG, GIF. Max 2MB.
                  </small>
                </div>
              </div>
            </div>

            <div
              className="col-md-6 mb-3"
              style={{ borderLeft: "1px solid #eee", paddingLeft: "1.5rem" }}
            >
              <label className="form-label">Clinic Images (Gallery)</label>
              <input
                type="file"
                multiple
                className="form-control"
                onChange={handleImageSelect}
              />
              <div className="d-flex flex-wrap mt-3" style={{ gap: "10px" }}>
                {clinicImages.map((image, index) => (
                  <div
                    key={index}
                    className="position-relative"
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: 8,
                      overflow: "hidden",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    <img
                      src={
                        image.preview
                          ? image.preview.startsWith("blob:")
                            ? image.preview
                            : `${imgUrl}${image.preview}`
                          : image.url || "https://via.placeholder.com/150"
                      }
                      alt={`clinic-img-${index}`}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => removeImage(index)}
                      className="i-btn-delete"
                      style={{
                        position: "absolute",
                        top: 4,
                        right: 4,
                        width: 22,
                        height: 22,
                        padding: 0,
                        fontSize: 14,
                        lineHeight: "1",
                      }}
                      title="Remove image"
                    ></button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Details Card (unchanged) */}
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Contact Details</h4>
          <div className="form-group">
            <label>Address Line 1</label>
            <input
              type="text"
              className="form-control"
              value={CDAddressLine1}
              onChange={(e) => setCDAddressLine1(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Address Line 2</label>
            <input
              type="text"
              className="form-control"
              value={CDAddressLine2}
              onChange={(e) => setCDAddressLine2(e.target.value)}
            />
          </div>
          <div className="row form-row">
            <div className="col-md-6">
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  className="form-control"
                  value={CDCity}
                  onChange={(e) => setCDCity(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>State</label>
                <input
                  type="text"
                  className="form-control"
                  value={CDState}
                  onChange={(e) => setCDState(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Zip Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={CDPostalCode}
                  onChange={(e) => setCDPostalCode(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Country</label>
                <input
                  type="text"
                  className="form-control"
                  value={CDCountry}
                  onChange={(e) => setCDCountry(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services and Specialization (unchanged) */}
      <div className="form-group">
        <label>Services</label>
        <input
          type="text"
          className="form-control"
          placeholder="Enter service and press Enter"
          value={serviceInput}
          onChange={(e) => setServiceInput(e.target.value)}
          onKeyDown={(e) => handleKeyPress(e, "service")}
        />
        <small className="form-text text-muted">
          Note: Type and press Enter to add new service
        </small>
        <div className="d-flex flex-wrap mt-3" style={{ gap: "10px" }}>
          {services.map((service, index) => (
            <span
              key={service.id || index}
              className="badge badge-info d-flex align-items-center"
              style={{ padding: "8px 12px", fontSize: "14px" }}
            >
              {service.service}
              <span
                style={{
                  cursor: "pointer",
                  marginLeft: "8px",
                  fontWeight: "bold",
                }}
                onClick={() => handleRemoveService(index)}
              >
                ×
              </span>
            </span>
          ))}
        </div>
      </div>
      {/* Specialization */}
      <div className="form-group mb-0">
        <label>
          Specialization <span className="text-danger">*</span>
        </label>

        <select
          className="form-control"
          value={
            specialization.length > 0 ? specialization[0].specialization : ""
          }
          onChange={(e) => {
            const selectedValue = e.target.value;
            if (selectedValue) {
              setSpecialization([
                {
                  id: specialization[0]?.id || null,
                  specialization: selectedValue,
                },
              ]);
            } else {
              setSpecialization([]);
            }
          }}
        >
          <option value="">-- Select Specialization --</option>
          {props.allSpecialities &&
            props.allSpecialities.map((spec) => (
              <option
                key={spec.id || spec.SpecID}
                value={spec.SpecialitiesName}
              >
                {spec.SpecialitiesName}
              </option>
            ))}
        </select>

        <small className="form-text text-muted">
          Note: Select your primary specialization from the list.
        </small>

        <div className="d-flex flex-wrap mt-3" style={{ gap: "10px" }}>
          {specialization.map((item, index) => (
            <span
              key={item.id || index}
              className="badge badge-info rounded-pill mb-2 d-flex align-items-center"
              style={{ padding: "8px 12px", fontSize: "14px" }}
            >
              {item.specialization}
              <span
                style={{
                  cursor: "pointer",
                  marginLeft: "8px",
                  fontWeight: "bold",
                }}
                onClick={() => handleRemoveSpecialization(index)}
              >
                ×
              </span>
            </span>
          ))}
        </div>
      </div>

      {/* Coupon Card (unchanged) */}
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Coupons</h4>
          {couponList.map((coupon, index) => (
            <div
              className="row form-row mb-3 align-items-center border-bottom pb-3"
              key={index}
            >
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <label className="small text-muted mb-1">
                    Coupon Name / Code
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g., SAVE20"
                    name="CouponName"
                    value={coupon.CouponName}
                    onChange={(e) => handleCouponChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group mb-md-0">
                  <label className="small text-muted mb-1">
                    Discount Percentage
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="e.g., 100"
                    name="DiscountPercent"
                    value={coupon.DiscountPercent}
                    onChange={(e) => handleCouponChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <label className="small text-muted mb-1">Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="StartDate"
                    value={coupon.StartDate}
                    onChange={(e) => handleCouponChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <label className="small text-muted mb-1">End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="EndDate"
                    value={coupon.EndDate}
                    onChange={(e) => handleCouponChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-1 text-right align-self-end pb-2">
                {couponList.length > 1 && (
                  <button
                    type="button"
                    className="i-btn-delete"
                    onClick={() => removeCoupon(index)}
                    title="Remove Coupon"
                  ></button>
                )}
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-info rounded-pill"
            onClick={addCoupon}
          >
            Add More Coupons
          </button>
        </div>
      </div>

      {/* Waiting Time Card (unchanged) */}
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Waiting Time</h4>
          <div id="waiting_time_select">
            <div className="form-check form-check-inline">
              <input
                type="radio"
                id="no_waiting_time"
                name="waiting_option"
                value="no_waiting"
                checked={waitingOption === "no_waiting"}
                onChange={() => setWaitingOption("no_waiting")}
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="no_waiting_time">
                No Waiting Time
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                type="radio"
                id="set_waiting_time"
                name="waiting_option"
                value="set_waiting"
                checked={waitingOption === "set_waiting"}
                onChange={() => setWaitingOption("set_waiting")}
                className="form-check-input"
              />
              <label className="form-check-label" htmlFor="set_waiting_time">
                Set Waiting Time
              </label>
            </div>
          </div>
          {waitingOption === "set_waiting" && (
            <div className="row mt-2">
              <div className="col-md-6">
                <input
                  type="text"
                  placeholder="e.g., '15 minutes'"
                  className="form-control"
                  value={waitingTime}
                  onChange={(e) => setWaitingTime(e.target.value)}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Payout Methods Card (unchanged) */}
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Payout Methods</h4>

          {!primaryPayment.type && (
            <div className="alert alert-warning mt-3" role="alert">
              <strong>Important:</strong> Please select one payment method as
              your primary for receiving payouts.
            </div>
          )}

          <ul className="nav nav-tabs nav-tabs-solid nav-justified mt-3">
            <li className="nav-item">
              <a
                className={`nav-link bg-info ${
                  paymentOption === "upi" ? "active" : ""
                }`}
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setPaymentOption("upi");
                }}
              >
                UPI
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link bg-info ${
                  paymentOption === "bank" ? "active" : ""
                }`}
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setPaymentOption("bank");
                }}
              >
                Bank Account
              </a>
            </li>
          </ul>
          <div className="tab-content pt-4">
            <div
              className={`tab-pane ${
                paymentOption === "upi" ? "show active" : ""
              }`}
            >
              {upiList.map((upi, index) => {
                const uniqueId = `upi-${upi.id || index}`;
                return (
                  <div
                    className="row form-row align-items-center mb-4 border-bottom pb-3"
                    key={uniqueId}
                  >
                    <div className="col-md-8">
                      <div className="form-group mb-0">
                        <label>UPI ID</label>
                        <input
                          type="text"
                          name="upiId"
                          className="form-control"
                          value={upi.upiId}
                          onChange={(e) =>
                            handlePaymentListChange(
                              index,
                              e,
                              upiList,
                              setUpiList,
                            )
                          }
                          placeholder="yourname@bank"
                        />
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-check pt-4">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="primary_payment_method"
                          id={uniqueId}
                          checked={primaryPayment.uniqueId === uniqueId}
                          onChange={() => handleSetPrimary("upi", uniqueId)}
                        />
                        <label className="form-check-label" htmlFor={uniqueId}>
                          Primary
                        </label>
                      </div>
                    </div>
                    <div className="col-md-1">
                      {upiList.length > 1 && (
                        <button
                          type="button"
                          className="i-btn-delete "
                          onClick={() => removeUpi(index)}
                          title="Remove UPI ID"
                        ></button>
                      )}
                    </div>
                  </div>
                );
              })}
              <button
                type="button"
                className="btn btn-info rounded-pill"
                onClick={addUpi}
              >
                Add More UPI
              </button>
            </div>
            <div
              className={`tab-pane ${
                paymentOption === "bank" ? "show active" : ""
              }`}
            >
              {bankList.map((bank, index) => {
                const uniqueId = `bank-${bank.id || index}`;
                return (
                  <div className="mb-4 border-bottom pb-3" key={uniqueId}>
                    <div className="row form-row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Account Holder's Name</label>
                          <input
                            type="text"
                            name="beneficiary_name"
                            className="form-control"
                            value={bank.beneficiary_name}
                            onChange={(e) =>
                              handlePaymentListChange(
                                index,
                                e,
                                bankList,
                                setBankList,
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Account Number</label>
                          <input
                            type="text"
                            name="account_number"
                            className="form-control"
                            value={bank.account_number}
                            onChange={(e) =>
                              handlePaymentListChange(
                                index,
                                e,
                                bankList,
                                setBankList,
                              )
                            }
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>IFSC Code</label>
                          <input
                            type="text"
                            name="ifsc_code"
                            className="form-control"
                            value={bank.ifsc_code}
                            onChange={(e) =>
                              handlePaymentListChange(
                                index,
                                e,
                                bankList,
                                setBankList,
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row form-row align-items-center">
                      <div className="col-md-11">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="primary_payment_method"
                            id={uniqueId}
                            checked={primaryPayment.uniqueId === uniqueId}
                            onChange={() => handleSetPrimary("bank", uniqueId)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={uniqueId}
                          >
                            Primary
                          </label>
                        </div>
                      </div>
                      <div className="col-md-1">
                        {bankList.length > 1 && (
                          <button
                            type="button"
                            className="delete-button  btn-sm"
                            onClick={() => removeBank(index)}
                          >
                            ×
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              <button type="button" className="add-button " onClick={addBank}>
                Add More Bank Accounts
              </button>
            </div>
          </div>
        </div>
      </div>
{/* ================= CLINIC SERVICE ================= */}

<div className="card">
  <div className="card-body">
    {/* Header + Switch */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h4 className="card-title mb-0">
        Clinic Consultation Online/Offline Prices
      </h4>

      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          checked={clinicStatus}
          onChange={(e) => {
            const isActive = e.target.checked;
            setClinicStatus(isActive);

            
            if (!isActive) {
              setOnlinePrice("");
              setOfflinePrice("");
            }
          }}
        />
        <label className="form-check-label ms-3">
          {clinicStatus ? "Active" : "Inactive"}
        </label>
      </div>
    </div>

    {/* WHEN SWITCH IS OFF */}
    {!clinicStatus && (
      <div className="alert alert-info mb-0">
        Turn on the switch above to enable clinic consultation settings.
      </div>
    )}

    {/* WHEN SWITCH IS ON */}
    {clinicStatus && (
      <>
        <h5 className="mb-3">Pricing</h5>

        <div className="row">
          {/* Online Price */}
          {/* <div className="col-md-6">
            <div className="form-group">
              <label>Online Price (per session)</label>
              <input
                type="number"
                min="0"
                className="form-control"
                placeholder="Enter online price"
                value={onlinePrice}
                onChange={(e) => setOnlinePrice(e.target.value)}
              />
            </div>
          </div>

        
          <div className="col-md-6">
            <div className="form-group">
              <label>Offline Price (per session)</label>
              <input
                type="number"
                min="0"
                className="form-control"
                placeholder="Enter offline price"
                value={offlinePrice}
                onChange={(e) => setOfflinePrice(e.target.value)}
              />
            </div>
          </div> */}
          {/* Online Price */}
<div className="col-md-6">
  <div className="form-group">
    <label>Online Price ({selectedCurrency?.symbol || '₹'})</label> {/* सिंबल यहाँ दिखेगा */}
    <div className="input-group">
      <span className="input-group-text">{selectedCurrency?.symbol || '₹'}</span>
      <input
        type="number"
        className="form-control"
        placeholder="Enter online price"
        value={onlinePrice}
        onChange={(e) => setOnlinePrice(e.target.value)}
      />
    </div>
  </div>
</div>

{/* Offline Price */}
<div className="col-md-6">
  <div className="form-group">
    <label>Offline Price ({selectedCurrency?.symbol || '₹'})</label>
    <div className="input-group">
      <span className="input-group-text">{selectedCurrency?.symbol || '₹'}</span>
      <input
        type="number"
        className="form-control"
        placeholder="Enter offline price"
        value={offlinePrice}
        onChange={(e) => setOfflinePrice(e.target.value)}
      />
    </div>
  </div>
</div>
        </div>
      </>
    )}
  </div>
</div>
{/* ================= VIDEO CONSULTANCY ================= */}

<div className="card">
  <div className="card-body">
    {/* Header + Switch/Badge */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h4 className="card-title mb-0">Video Consultation Online Prices</h4>

      {hasActiveVideoAddon ? (
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="videoStatusToggle"
            checked={videoStatus}
            onChange={(e) => {
              const isActive = e.target.checked;
              setVideoStatus(isActive);

             
              if (!isActive) setVideoConsultancyPrice("");
            }}
          />
          <label className="form-check-label ms-3" htmlFor="videoStatusToggle">
            {videoStatus ? "Active" : "Inactive"}
          </label>
        </div>
      ) : (
        <span className="badge bg-warning text-dark">Addon Required</span>
      )}
    </div>

    {/* CASE 1: No Addon subscribe  */}
    {!hasActiveVideoAddon ? (
      <div className="alert alert-warning border-0 shadow-sm mb-0">
        <div className="d-flex align-items-center">
          <i className="fas fa-video-slash me-3 fa-2x"></i>
          <div>
            <strong>Video Consultancy Addon Required!</strong>
            <p className="mb-2">
              You have not subscribed to the Video Consultancy Addon. Please select a plan to enable this feature.
            </p>
            <Link to="/doctor/plan-selection" className="btn btn-info btn-sm rounded-pill">
              <i className="fas fa-crown me-2"></i> Subscribe Now
            </Link>
          </div>
        </div>
      </div>
    ) : (
      /* CASE 2: valid Addon  */
      <>
        {/* WHEN SWITCH IS OFF */}
        {!videoStatus && (
          <div className="alert alert-info mb-0">
            Turn on the switch above to enable video consultation settings.
          </div>
        )}

        {/* WHEN SWITCH IS ON */}
        {videoStatus && (
          <>
            <h5 className="mb-3">Pricing</h5>
            <div className="row">
              <div className="col-md-6">
                {/* <div className="form-group">
                  <label>Video consultation price (per session)</label>
                  <input
                    type="number"
                    min="0"
                    className="form-control"
                    placeholder="Enter video call price"
                    value={videoConsultancyPrice}
                    onChange={(e) => setVideoConsultancyPrice(e.target.value)}
                  />
                </div> */}
                <div className="form-group">
  <label>Video consultation price ({selectedCurrency?.symbol || '₹'})</label>
  <div className="input-group">
    <span className="input-group-text">{selectedCurrency?.symbol || '₹'}</span>
    <input
      type="number"
      className="form-control"
      placeholder="Enter video call price"
      value={videoConsultancyPrice}
      onChange={(e) => setVideoConsultancyPrice(e.target.value)}
    />
  </div>
</div>
              </div>
            </div>
          </>
        )}
      </>
    )}
  </div>
</div>

{/* ================= HOME VISIT ================= */}
<div className="card">
  <div className="card-body">
    {/* Header + Switch/Badge */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h4 className="card-title mb-0">Home Consultation Online/Offline Prices</h4>

      {hasActiveHomeAddon ? (
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            id="homeStatusToggle"
            checked={homeStatus}
            onChange={(e) => {
              const isActive = e.target.checked;
              setHomeStatus(isActive);

             
              if (!isActive) {
                setHomeVisitPriceOnline("");
                setHomeVisitPriceOffline("");
              }
            }}
          />
          <label className="form-check-label ms-3" htmlFor="homeStatusToggle">
            {homeStatus ? "Active" : "Inactive"}
          </label>
        </div>
      ) : (
        <span className="badge bg-warning text-dark">Addon Required</span>
      )}
    </div>

    {/* CASE 1: No Addon subscribe  */}
    {!hasActiveHomeAddon ? (
      <div className="alert alert-warning border-0 shadow-sm mb-0">
        <div className="d-flex align-items-center">
          <i className="fas fa-home me-3 fa-2x"></i>
          <div>
            <strong>Home Consultation Addon Required!</strong>
            <p className="mb-2">
              You have not subscribed to the Home Consultancy Addon. Please select a plan to enable this feature.
            </p>
            <Link to="/doctor/plan-selection" className="btn btn-info btn-sm rounded-pill">
              <i className="fas fa-crown me-2"></i> Subscribe Now
            </Link>
          </div>
        </div>
      </div>
    ) : (
      /* CASE 2:Valid Addon  */
      <>
        {/* WHEN SWITCH IS OFF */}
        {!homeStatus && (
          <div className="alert alert-info mb-0">
            Turn on the switch above to enable home visit settings.
          </div>
        )}

        {/* WHEN SWITCH IS ON */}
        {homeStatus && (
          <>
            <h5 className="mb-3">Home Visit Pricing</h5>
            <div className="row mb-4">
              {/* Online Price */}
              {/* <div className="col-md-6">
                <div className="form-group">
                  <label>Online Price (per session)</label>
                  <input
                    type="number"
                    min="0"
                    className="form-control"
                    placeholder="Enter online home visit price"
                    value={homeVisitPriceOnline}
                    onChange={(e) => setHomeVisitPriceOnline(e.target.value)}
                  />
                </div>
              </div> */}

              {/* Offline Price */}
              {/* <div className="col-md-6">
                <div className="form-group">
                  <label>Offline Price (per session)</label>
                  <input
                    type="number"
                    min="0"
                    className="form-control"
                    placeholder="Enter offline home visit price"
                    value={homeVisitPriceOffline}
                    onChange={(e) => setHomeVisitPriceOffline(e.target.value)}
                  />
                </div>
              </div> */}
              {/* Online Price */}
<div className="col-md-6">
  <div className="form-group">
    <label>Online Price ({selectedCurrency?.symbol || '₹'})</label>
    <div className="input-group">
      <span className="input-group-text">{selectedCurrency?.symbol || '₹'}</span>
      <input
        type="number"
        className="form-control"
        value={homeVisitPriceOnline}
        onChange={(e) => setHomeVisitPriceOnline(e.target.value)}
      />
    </div>
  </div>
</div>

{/* Offline Price */}
<div className="col-md-6">
  <div className="form-group">
    <label>Offline Price ({selectedCurrency?.symbol || '₹'})</label>
    <div className="input-group">
      <span className="input-group-text">{selectedCurrency?.symbol || '₹'}</span>
      <input
        type="number"
        className="form-control"
        value={homeVisitPriceOffline}
        onChange={(e) => setHomeVisitPriceOffline(e.target.value)}
      />
    </div>
  </div>
</div>
            </div>

            {/* Pincode Section */}
            <div className="pincode-management mt-3">
              <h6 className="mb-3 fw-bold">Available Pincodes</h6>
              {pincodeList.map((p, index) => (
                <div key={index} className="d-flex mb-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Pincode"
                    value={p.pincode}
                    onChange={(e) => handlePincodeChange(index, e)}
                  />
                  {pincodeList.length > 1 && (
                    <button 
                      type="button" 
                      className="i-btn-delete " 
                      onClick={() => removePincode(index)}
                    >
                      
                    </button>
                  )}
                </div>
              ))}
              <button 
                type="button" 
                className="btn btn-info rounded-pill mt-2" 
                onClick={addPincode}
              >
                + Add Pincode
              </button>
            </div>
          </>
        )}
      </>
    )}
  </div>
</div>

      {/* Education, Experience, Awards, Membership, Registration Cards (unchanged) */}
      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Education</h4>
          {educationList.map((education, index) => (
            <div className="row form-row mb-3 align-items-center" key={index}>
              <div className="col-md-4">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Degree"
                    name="degree"
                    value={education.degree}
                    onChange={(e) => handleEducationChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="College/Institute"
                    name="college"
                    value={education.college}
                    onChange={(e) => handleEducationChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Year of completion"
                    name="year"
                    value={education.year}
                    onChange={(e) => handleEducationChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-1 text-right">
                {educationList.length > 1 && (
                  <button
                    type="button"
                    className="i-btn-delete"
                    onClick={() => removeEducation(index)}
                    title="Remove Education"
                  ></button>
                )}
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-info rounded-pill"
            onClick={addEducation}
          >
            Add More
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Experience</h4>
          {experienceList.map((experience, index) => (
            <div className="row form-row mb-3 align-items-center" key={index}>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Hospital Name"
                    name="hospital"
                    value={experience.hospital}
                    onChange={(e) => handleExperienceChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="From"
                    name="from"
                    value={experience.from}
                    onChange={(e) => handleExperienceChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="To"
                    name="to"
                    value={experience.to}
                    onChange={(e) => handleExperienceChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Designation"
                    name="designation"
                    value={experience.designation}
                    onChange={(e) => handleExperienceChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-1 text-right">
                {experienceList.length > 1 && (
                  <button
                    type="button"
                    className="i-btn-delete "
                    onClick={() => removeExperience(index)}
                    title="Remove Experience "
                  ></button>
                )}
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-inf0 rounded-pill"
            onClick={addExperience}
          >
            Add More
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Awards</h4>
          {awardsList.map((award, index) => (
            <div className="row form-row mb-3 align-items-center" key={index}>
              <div className="col-md-6">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Award"
                    name="award"
                    value={award.award}
                    onChange={(e) => handleAwardsChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Year"
                    name="year"
                    value={award.year}
                    onChange={(e) => handleAwardsChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-1 text-right">
                {awardsList.length > 1 && (
                  <button
                    type="button"
                    className="i-btn-delete "
                    onClick={() => removeAwards(index)}
                    title="Remove Awards "
                  ></button>
                )}
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-info rounded-pill mt-2"
            onClick={addAwards}
          >
            Add More
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Membership</h4>
          {membershipList.map((membership, index) => (
            <div className="row form-row mb-3 align-items-center" key={index}>
              <div className="col-md-6">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Membership"
                    name="membership"
                    value={membership.membership}
                    onChange={(e) => handleMembershipChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Year"
                    name="year"
                    value={membership.year}
                    onChange={(e) => handleMembershipChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-1 text-right">
                {membershipList.length > 1 && (
                  <button
                    type="button"
                    className="i-btn-delete"
                    onClick={() => removeMembership(index)}
                    title="Remove Membership"
                  ></button>
                )}
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-info rounded-pill"
            onClick={addMembership}
          >
            Add More
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h4 className="card-title">Registration</h4>
          {registrationList.map((registration, index) => (
            <div className="row form-row mb-3 align-items-center" key={index}>
              <div className="col-md-6">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Registration"
                    name="registration"
                    value={registration.registration}
                    onChange={(e) => handleRegistrationChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-md-0">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Year"
                    name="year"
                    value={registration.year}
                    onChange={(e) => handleRegistrationChange(index, e)}
                  />
                </div>
              </div>
              <div className="col-md-1 text-right">
                {registrationList.length > 1 && (
                  <button
                    type="button"
                    className="i-btn-delete"
                    onClick={() => removeRegistration(index)}
                    title="Remove Registeration"
                  ></button>
                )}
              </div>
            </div>
          ))}
          <button
            type="button"
            className="btn btn-info rounded-pill mt-2"
            onClick={addRegistration}
          >
            Add More
          </button>
        </div>
      </div>

      {!profileData && (
        <div className="text-center m-3">
          <button
            type="button"
            className="btn-info btn "
            onClick={handleSubmit}
          >
            Save Profile
          </button>
        </div>
      )}
      {profileData && (
        <div className="text-center m-3">
          <button
            type="button"
            className="btn btn-success rounded-pill"
            onClick={handleEdit}
          >
            Edit Profile
          </button>
        </div>
      )}

      <MessageModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        title={modalTitle}
        message={modalMessage}
        variant={modalVariant}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  userList: Array.isArray(state.loginReducer?.userList?.data)
    ? state.loginReducer.userList.data
    : [],
  profileData: state.doctorProfile.profileData,
  allSpecialities: state.specialities.specialities || [],
   selectedCurrency: state.currencyReducer.selectedCurrency,
});

export default connect(mapStateToProps, {
  getAllUsers,
  updateDoctorProfileInfo,
  getDoctorProfileById,
  getAccountStatus,
  fetchSpecialities,
  getBusinessAddons,
})(DoctorProfileForm);
